export enum StartOption {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  ADDRESS = 'address',
  CITY = 'city',
  DATE_OF_BIRTH = 'date_of_birth',
  EMAIL = 'email',
  INCOME = 'income',
  MOBILE = 'mobile',
  POSTAL_CODE = 'postal_code',
  REGION = 'region',
  SSN = 'ssn',
}
